export const VERIFICATION_FIELDS = {
  deductible_remaining: 'deductible_remaining',
  new_verification_toggle: 'new_verification_toggle',
  status: 'verification_status',
  verified_through: 'verified_through',
  verified_via: 'verified_via_id',
  service_code: 'service_code',
  vob_notes: 'vob_notes',
  estimated_monthly_cost: 'estimated_monthly_cost_in_cents',
  estimated_initial_month_cost: 'estimated_initial_month_cost_in_cents'
};
